import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    createCopyLink,
    getImagePath,
    getImagePathSvg,
    getImagePathWithTheme, getItem, getLocalFilePath, getSafeString,
    getTimeText,
    isAudio,
    isDarkMode, isObject, isYoutubeUrl, sleep
} from "../../../../../src/utils";
import clipboard from "clipboardy";
import i18n, {t} from "i18next";
import global from "../../../../../src/global";
import {isZh} from "../../../../../src/language";
import {ipcSend} from "../../../../../src/common/ipc";
import { Dropdown, message ,Tooltip} from "antd";
import {
    IconCopyAgain00000,
    IconCopyLink,
    IconCopyText,
    IconDelete,
    IconEdit,
    IconInfoMenu,
    IconMakeCopy,
    IconManagerTags
} from "../../../../../src/Icon";
import {getTransctiptById} from "../../../../../model";
import {FROM_HOME_DIALOG} from "../../../../../src/Const";
import {saveElementVideoNotesAsJSON} from "../../data/json";

const VideoTranscript = forwardRef((props:{element:any,from:any,subFrom:any,onShowImportTranscript:any,onClickItem:any,onQuickNote:any,type:any,onExpand:any,onHasTranscript:any,onGetData:any,transcriptData:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onScrollToTime:onScrollToTime,
        onSearch:onSearch,
        refreshTranscript:refreshTranscript,
        onExportTranscript:onExportTranscript,
        onExportTranscriptToFile:onExportTranscriptToFile
    }))
    const {element,from} = props;
    const [transcript,setTranscript] = useState<any>(props.transcriptData);
    const [activeItem,setActiveItem] = useState(null);
    const mSelectItem = useRef<any>(null);
    const [isExpand,setIsExpand] = useState(false);
    const [hasTranscript,setHasTranscript] = useState(false);
    const [hasTranscript1,setHasTranscript1] = useState(true);
    const scrollContainerRef = useRef(null);
    const mIsScrollByCode = useRef(false);
    const mUserScrollTime = useRef(0);
    const mCurrentScrollItemId = useRef('');
    const mUserScrollTimerId = useRef<any>(0);
    const [pageNum,setPageNum] = useState(0);
    const mPageSize = 50;
    const mTranscriptRef = useRef<any>(props.transcriptData);

    const MORE_MENU = [
        getItem(i18n.t("Edit transcript"), 'edit', <IconEdit/>, undefined, undefined, () => {
            editTranscript();
        }),
        getItem(i18n.t("Copy link"), 'copyLink', <IconCopyAgain00000/>, undefined, undefined, (e) => {
            e.domEvent.stopPropagation();
            createCopyLink('library',props.element.customData?.generationData?.id,'transcript',mSelectItem.current?.id);
        }),
    ]

    useEffect(() => {
        mTranscriptRef.current = transcript;
    }, [transcript]);

    useEffect(()=>{
        refreshTranscript();
        window.refreshList['refresh_transcript_'] = refreshTranscript;

        return ()=>{
            delete window.refreshList['refresh_transcript_'];
        }
    },[props.element])

    useEffect(() => {
        if (props.onExpand){
            props.onExpand(isExpand);
        }

    }, [isExpand]);

    useEffect(() => {
        if (props.onHasTranscript){
            props.onHasTranscript(hasTranscript);
        }

    }, [hasTranscript]);

    /**
     * 自动滚动到时间...
     * @param lTime
     */
    const onScrollToTime = (lTime)=>{
        if ((Date.now() - mUserScrollTime.current) < 2000) {
            return
        };
        //找到这个时间所在的条目...
        const item = mTranscriptRef.current?.data.find(p=>p.start <= lTime && lTime < p.end);
        if (item){
            if (mCurrentScrollItemId.current == item.id){
                return;
            }

            mCurrentScrollItemId.current = item.id;
            mIsScrollByCode.current = true;
            clearTimeout(mUserScrollTimerId.current);
            setActiveItem(item);
            if (props.subFrom == FROM_HOME_DIALOG){
                onScrollToTime0(lTime)
            }else{
                const div = document.getElementById(`div-video-transcript-item-${props.element.id}-` + item.id);
                if (div){
                    div.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }else{
                    //没有加载到，需要重新加载，然后再滚动...
                    reCalcLoading(item);
                    setTimeout(()=>{
                        onScrollToTime(lTime);
                    },600)
                }
            }

            mUserScrollTimerId.current = setTimeout(()=>{
                mIsScrollByCode.current = false;
            },1000)

        }
    }

    const onScrollToTime0 = async (lTime) => {
        const item = mTranscriptRef.current.data.find(p => p.start <= lTime && lTime < p.end);
        if (!item || !scrollContainerRef.current) {
            return
        };

        setActiveItem(item);
        const div = document.getElementById(`div-video-transcript-item-${props.element.id}-${item.id}`);
        if (!div) {
            //没有加载到，需要重新加载，然后再滚动...
            reCalcLoading(item);
            setTimeout(()=>{
                onScrollToTime(lTime);
            },600)
            return;
        }

        await sleep(300);

        // 获取容器和目标元素的位置
        const container = scrollContainerRef.current;
        const containerRect = container.getBoundingClientRect();
        const elementRect = div.getBoundingClientRect();

        // 计算元素在容器内的相对位置
        const elementTopInContainer = elementRect.top - containerRect.top + container.scrollTop;

        // 目标滚动位置：让元素居中（减去顶部偏移，比如你想留 40px 空间）
        const offsetTop = 40; // ← 根据你的 UI 调整，比如顶部有操作栏
        const targetScrollTop = elementTopInContainer - container.clientHeight / 2 + offsetTop;

        // 执行滚动
        container.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth' // 可选
        });
    };

    /**
     * 没有加载到的情况下，重新加载更多数据...
     * @param item
     */
    const reCalcLoading = (item)=>{
        mCurrentScrollItemId.current = '';
        const nIndex = mTranscriptRef.current.data.findIndex(p=>p.id == item.id);
        let nPageNum = Math.ceil(nIndex/50) + 1;
        setPageNum(nPageNum);
    }

    /**
     * 搜索
     * @param szSearchKey
     */
    const onSearch = (szSearchKey:any)=>{
        refreshTranscript(szSearchKey);
    }

    const getCurrentElementTranscript = ()=>{
        const exportValues = {
            videoTitle: props.element.customData?.generationData?.name,
            pastedText: transcript.data.reduce((pre, item) => {
                return `${pre}${item.id}\n${item.content}\n`;
            }, ""),
        };
        return exportValues;
    }

    const onExportTranscript = async ()=>{
        const text = getCurrentElementTranscript();
        await navigator.clipboard.writeText(text.pastedText);
        message.info(t('Has copyed'))
    }

    const onExportTranscriptToFile = ()=>{
        const exportData = getCurrentElementTranscript();
        saveElementVideoNotesAsJSON(exportData,'srt');
    }

    /**
     * 刷新字幕
     */
    const refreshTranscript = (szSearchKey='')=>{
        if (!props.element.customData?.generationData?.id){
            props.element.customData.generationData.id = props.element.id;
        }
        getTransctiptById(props.element.customData?.generationData?.id || props.element.id).then(res=>{
            if (res){
                if (szSearchKey){
                    const arrayDatas = res.data.filter(p=>getSafeString(p.content).toLowerCase().includes(szSearchKey));
                    res.data = arrayDatas;
                }
                mTranscriptRef.current = res;
                setTranscript(res);
                // setIsExpand(res.data.length > 0);
                if (!szSearchKey){
                    setHasTranscript(res.data.length > 0);
                }

                setHasTranscript1(res.data.length > 0);

                if (isObject(props.element.selectedId)){
                    //转到这个。。。。
                    const item = res.data.find(p=>p.id == props.element.selectedId?.selectId);
                    setTimeout(()=>{
                        window.globalRefreshList('show_transcript_in_dialog_');
                        setActiveItem(item);
                        //定位到这个.
                        onScrollToTime(item.start);
                        if (props.onClickItem){
                            props.onClickItem(item,true);
                        }
                    },300)
                    props.element.selectedId = null;
                }
            }else{
                setHasTranscript(false);
                setHasTranscript1(false);
                setTranscript(null)
            }
            if (props.onGetData){
                props.onGetData(res);
            }
        })
    }

    const editTranscript = ()=>{
        window.showDialogEditTranscript(transcript,mSelectItem.current,(newTranscript:any)=>{
            setTranscript(newTranscript);
        })
    }


    return <div style={{width: '100%',height:'100%',display:'flex',flexDirection:'column'}}>
        <div ref={scrollContainerRef} style={{overflow: 'auto', height: 'calc(100% - 0px)', width: '100%',marginTop:'10px',}} onScroll={(e)=>{

            let he = e.currentTarget.scrollHeight - e.currentTarget.clientHeight - e.currentTarget.scrollTop
            // console.log(he);
            if (he > -20 && he < 20) {
                console.log('scroll end*************');
                setPageNum(pageNum+1);
            }
            if (mIsScrollByCode.current) {

            }else {
                mUserScrollTime.current = Date.now();
            }
            // mIsScrollByCode.current = false;
        }}>
        {transcript?.data?.slice(0,(pageNum+1)*mPageSize).map((item, index) => {
            if (!item) return <></>
            const getClassName = () => {
                if (`${activeItem?.id}` == `${item.id}`) {
                    return "one-note-transcript one-note-transcript-acitve";
                }
                return "one-note-transcript";
            }
            return (
                <Dropdown /*open={isContextMenuOpen}*/ menu={{items: MORE_MENU}}
                                                       overlayClassName={'default-dropdown-style'}
                                                       trigger={["contextMenu"]}
                                                       onOpenChange={(e) => {
                                                           if (global.g_isPresentMode) {
                                                               // setIsContextMenuOpen(false);
                                                               return;
                                                           }
                                                           if (e) {
                                                               mSelectItem.current = item;
                                                           }
                                                           // setIsContextMenuOpen(e);
                                                       }}>
                    <div
                        id={`div-video-transcript-item-${props.element.id}-` + item.id}
                        draggable={true}
                        style={{marginRight: (from == 'slider') ? '0px' : '18px'}}
                        className={
                            getClassName()
                        }
                        key={item.id} onClick={(e)=>{
                            setActiveItem(item);
                            props.onClickItem(item);
                    }} >

                        <div className={'flex-row'}>
                            <div style={{width:'100%'}}>
                                <div className="one-title" style={{marginTop: '0px',position:'relative',display:'flex'}}>
                                      <span className={''}
                                            style={{
                                                fontSize: '12px',
                                                color: 'var(--color-666666)',
                                            }}>{item.id}</span>
                                    <span style={{
                                        color: 'var(--text-color)',
                                        fontSize: '12px',
                                        marginLeft:'6px',
                                        display: 'block'
                                    }}
                                          className={(!item.title && item.thumbImage) ? "one-note-content-30" : "one-note-content0"}>{item.content}</span>

                                    <div className="one-header-right flex-row-vertical-center"
                                         style={{
                                             display: global.g_isPresentMode ? 'none' : 'inherit',
                                             marginLeft: 'auto',
                                             position:'absolute',
                                             right:'0px',top:'-4px'
                                         }}>
                                        <Tooltip arrow={false} title={t('Quick note')}>
                                            <div className={'flex-center'}
                                                 style={{width:'30px',height:'30px'}}>
                                                <img className={'img-30'}
                                                     style={{marginTop: '-1px'}}
                                                     src={getImagePathWithTheme('video_transcript_anno_1.svg')}
                                                     onClick={(e) => {
                                                         e.stopPropagation();
                                                         props.onQuickNote(item);
                                                     }}
                                                />
                                            </div>

                                        </Tooltip>

                                        <Tooltip arrow={false} title={t('Copy')}>
                                            <div className={'flex-center ml-0'} style={{
                                                width: '30px',
                                                height: '30px',
                                            }}>
                                                <img className={'img-30 '}
                                                     src={getImagePathWithTheme('video_transcript_copy_1.svg')}
                                                     onClick={(e) => {
                                                         e.stopPropagation();
                                                         clipboard.write(item.content);
                                                         message.info(t('TextCopiedToClipboard'))
                                                     }}
                                                />
                                            </div>
                                        </Tooltip>

                                        <Dropdown overlayClassName={'default-dropdown-style'}
                                                  menu={{items: MORE_MENU}} trigger={["click"]}
                                                  onOpenChange={(e) => {
                                                      if (e) {
                                                          mSelectItem.current = item;
                                                      }
                                                  }}>
                                            <div className={'flex-center ml-0'} style={{
                                                width: '30px',
                                                height: '30px',
                                            }} onClick={(e) => {
                                                e.stopPropagation();
                                                // mSelectItem.current = item;
                                            }}>
                                                <img className={'img-30 '}
                                                     src={getImagePathWithTheme('video_transcript_more_1.svg')}
                                                     />
                                            </div>
                                        </Dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dropdown>
            );
        })}
        </div>

        {
            !global.g_isPresentMode && props.type != 'dialogOnlyTranscript' && !hasTranscript1 &&
            <>
                <div style={{}} className={'line'}></div>
                <div className="video-note-bottom">
                    <div className={'button-border-style flex-center border-radius-8 cursor-pointer'}
                         style={{
                             height: '40px',
                             flexGrow: '1',
                             maxWidth: '260px'
                         }} onClick={(e) => {
                        props.onShowImportTranscript();
                    }}>
                        <img className={'img-16'} src={getImagePathSvg('import_transcript')}/>
                        <span className={'ml-8'}
                              style={{color: 'var(--primary-color)'}}>{i18n.t("Import transcript")}</span>
                    </div>
                </div>
                {
                    isYoutubeUrl(element.link) &&
                    <div className={'flex-center mt-16'}>
                        <span className={'cursor-pointer'} style={{textDecoration: 'underline'}} onClick={(e) => {
                            if (isZh()) {
                                ipcSend('open-url', import.meta.env.VITE_HTTP_TRANSCRIPT_ZH);
                            } else {
                                ipcSend('open-url', import.meta.env.VITE_HTTP_TRANSCRIPT);
                            }
                        }}>{i18n.t("VisitOurWebTool")}</span>
                    </div>
                }

            </>
        }

        {
            !hasTranscript1 && props.type != 'dialogOnlyTranscript' &&
            <span className={'video-note-wrapper-no-data'}
                  style={{color: isDarkMode() ? '#BAB8B8' : 'var(--color-9A9A9A)'}}>{i18n.t(isAudio(element.customData?.generationData.fileName) ? "NoAudioTranscript" : "NoVideoTranscript")}</span>
        }
    </div>
})

export default VideoTranscript;